module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-150x150-742254c48b1ef834a88ffa7ed17bd06a.png";